import { css } from 'styled-components';

import { type Theme } from '@/utils/theme/themes';

export const styles = {
  heroFadeIn: 'hero-fade-in'
};

export const AnimationDeclarations = css<{ theme?: Theme }>`
  :root {
    // https://www.kvin.me/css-springs { bounce: 0, duration: 450ms }
    --spring-easing: linear(
      0,
      0.0007 0.36%,
      0.0058 1.08%,
      0.0217,
      0.0454 3.23%,
      0.086 4.66%,
      0.1594 6.81%,
      0.4654 15.05%,
      0.5681 18.28%,
      0.6468 21.15%,
      0.7212,
      0.782 27.6%,
      0.8355,
      0.8769 34.77%,
      0.8968,
      0.9137,
      0.928 41.22%,
      0.9419,
      0.9531 46.24%,
      0.9635 49.1%,
      0.9786 55.2%,
      0.9888 62.36%,
      0.9949 70.97%,
      0.9982 82.44%,
      0.9997 100%
    );
    --spring-duration: 0.747s;
  }

  @keyframes hero-fade-in {
    from {
      opacity: 0.0001;
      transform: translateY(var(--y, 32px));
    }
    to {
      opacity: 1;
      transform: none;
    }
  }

  .${styles.heroFadeIn} {
    animation: var(--spring-duration) var(--spring-easing) 0.2s hero-fade-in;
    animation-fill-mode: both;
  }
`;
